import courseApi, { COURSE_ENDPOINT } from '@redux/course/api';
import { HttpFetchCurriculumVideoPreviewApiResponse } from '@redux/course/type/courseDetailType';
import useSWR from 'swr';

const { fetchCurriculumVideoPreview } = courseApi;

export const useCurriculumPreview = (idName: string, chapterId: number) => {
  const { data } = useSWR<HttpFetchCurriculumVideoPreviewApiResponse>(
    COURSE_ENDPOINT.CURRICULUM_VIDEO_PREVIEW(idName, chapterId),
    () => fetchCurriculumVideoPreview({ courseIdOrIdName: idName, chapterId }),
  );

  const videoPreviewData = data?.data;
  const videoPreviewUrl = videoPreviewData?.videoUrl;
  const videoPreviewSubtitles = videoPreviewData?.subtitles;

  return {
    videoPreviewUrl,
    videoPreviewSubtitles,
  };
};
